import React from 'react';
import PropTypes from 'prop-types';
import './AuthButton.css';

const AuthButton = ({
  children,
  onClick,
  type,
  disabled,
  loading,
  variant,
  fullWidth,
  className,
}) => {
  const buttonClasses = [
    'auth-btn',
    variant === 'secondary' ? 'auth-btn--secondary' : 'auth-btn--primary',
    fullWidth ? 'auth-btn--full-width' : '',
    className || '',
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type || 'button'}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? 'Loading...' : children}
    </button>
  );
};

AuthButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary']),
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

AuthButton.defaultProps = {
  type: 'button',
  disabled: false,
  loading: false,
  variant: 'primary',
  fullWidth: true,
};

export default AuthButton;
